export default __webpack_public_path__ + "static/11-86586682dc6cf957e0878bba398aa47d.png";